const Loader = () => {
    return (
        <div className="df row center m-v-primary waves-outer">
            <div className="waves df center">

            </div>
        </div>
    )
}
export default Loader;